import { useContext } from 'react';

import { Box, Button, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { keyframes } from '@mui/system';

import DrawerBody from './DrawerBody';
import DrawerFooter from './DrawerFooter';
import { DrawerComponentProps } from './DrawerManager';
import DrawerTitle from './DrawerTitle';
import { AnalyticsContext, ObjectTypes } from 'src/AnalyticsContext';
import LightbulbIcon from 'src/assets/images/insights-icons/lightbulb-icon.svg';
import NewChip from 'src/assets/images/insights-icons/new-chip.svg';

const newChipKeyframes = keyframes`
    0% {
        transform: scale(0.75) translate(0, 10%);
        opacity: 0;
    }
    25% {
        opacity: 1;
    }
    75% {
        transform: scale(1.2) translate(0, 5%);
    }
    100% {
        transform: scale(1) translate(0, 0);
        opacity: 1;
    }
`;

function ExploreInsightsDrawer(props: DrawerComponentProps) {
    const { onClose, onNext } = props;
    const { spacing, palette } = useTheme();
    const { trackEvent } = useContext(AnalyticsContext);

    const handleGoBack = () => {
        trackEvent('Later Button Clicked', {
            objectType: ObjectTypes.Button,
            buttonLabel: 'Later',
            context: 'Explore Insights Drawer',
        });
        onClose();
    };

    return (
        <>
            <DrawerTitle sx={{ pt: 4 }}>
                <Box sx={{ position: 'relative' }}>
                    <Box
                        component="img"
                        alt="Lightbulb"
                        src={LightbulbIcon}
                        sx={{
                            position: 'relative',
                            width: spacing(7.5),
                        }}
                    />
                    <Box
                        component="img"
                        alt="New"
                        src={NewChip}
                        sx={{
                            position: 'absolute',
                            top: spacing(-0.5),
                            left: spacing(5),
                            boxShadow: `0px 4px 12px 0px ${alpha(palette.purple?.[900], 0.6)}`,
                            borderRadius: spacing(0.5),
                            animation: `${newChipKeyframes} 0.5s ease-out 0.5s 1 forwards`,
                        }}
                    />
                </Box>
                <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                    Explore New Insights
                </Typography>
            </DrawerTitle>
            <DrawerBody sx={{ pt: 1 }}>
                <Typography variant="body2">
                    Sage surfaces key insights to identify opportunities at your community. Review
                    the newest data and consider actions to take.
                </Typography>
            </DrawerBody>
            <DrawerFooter sx={{ gap: 2.5 }}>
                <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    disableElevation
                    onClick={onNext}
                >
                    View Insights
                </Button>

                <Button color="primary" disableElevation fullWidth onClick={handleGoBack}>
                    Later
                </Button>
            </DrawerFooter>
        </>
    );
}

export default ExploreInsightsDrawer;
